// extracted by mini-css-extract-plugin
export var aircallIframe = "_lg-3";
export var fabContainer = "_lg-5";
export var fabRinging = "_lg-6";
export var loadingOverlay = "_lg-4";
export var pulse = "_lg-7";
export var widgetContent = "_lg-2";
export var widgetPanel = "_lg-0";
export var widgetPanelExpanded = "_lg-1";